import type * as Types from '../../graphql/types.d'

import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type TripQueryVariables = Types.Exact<{
	tripId: Types.Scalars['ID']['input']
}>

export type TripQuery = {
	__typename?: 'Query'
	trip: {
		__typename: 'Trip'
		id: string
		title?: string | null
		description?: string | null
		departAt?: string | null
		returnAt?: string | null
		isOwner: boolean
		isPurchased: boolean
		isIndestructible: boolean
		numBlocks: number
		numHighlights: number
		numDestinations: number
		numSources: number
		weekendCostRangeUpper?: number | null
		weekendCostRangeLower?: number | null
		weekCostRangeUpper?: number | null
		weekCostRangeLower?: number | null
		monthCostRangeUpper?: number | null
		monthCostRangeLower?: number | null
		categories?: Array<string> | null
		unpublishedListing?: {
			__typename: 'Listing'
			hasUnpublishedChanges: boolean
			id: string
			isPublished: boolean
			rank: number
			title?: string | null
			description?: string | null
			basePrice?: number | null
			currency: string
			viewsCount: number
			thankYouMessage?: string | null
			suggestedPrice?: number | null
			avgRating: number
			numReviews: number
			owner: {
				__typename: 'User'
				id: string
				bio?: string | null
				instagramUsername?: string | null
				tiktokUsername?: string | null
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
			}
			reviews?: Array<{
				__typename: 'Review'
				id: string
				starRating: number
				feedbackToCreator?: string | null
				comment?: string | null
				createdAt: string
				reviewer: {
					__typename: 'User'
					id: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
			}> | null
		} | null
		orderedBlocks: Array<{
			__typename: 'OptionSegment'
			id: string
			rootBlock: { __typename: 'Block'; id: string }
			destinationSegments: Array<{
				__typename: 'DestinationSegment'
				id: string
				destinationBlock: {
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				}
				extraBlocks: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					childBlocks: Array<{
						__typename: 'Block'
						id: string
						description?: string | null
						title?: string | null
						createdAt: string
						isOrigin: boolean
						isDestination: boolean
						isRootBlock: boolean
						blockType: Types.BlockType
						parentId?: string | null
						numInList?: number | null
						numHighlights?: number | null
						rootId?: string | null
						position: number
						icon: Types.CustomIcon
						color: Types.CustomColor
						queryPosition: number
						childBlocks: Array<{
							__typename: 'Block'
							id: string
							description?: string | null
							title?: string | null
							createdAt: string
							isOrigin: boolean
							isDestination: boolean
							isRootBlock: boolean
							blockType: Types.BlockType
							parentId?: string | null
							numInList?: number | null
							numHighlights?: number | null
							rootId?: string | null
							position: number
							icon: Types.CustomIcon
							color: Types.CustomColor
							queryPosition: number
							blockAncestors: Array<{
								__typename: 'Block'
								id: string
								title?: string | null
								blockType: Types.BlockType
							} | null>
							destination?: {
								__typename: 'Location'
								id: string
								lat: number
								lng: number
								type?: Types.LocationType | null
								shortName?: string | null
								longName?: string | null
								address?: string | null
								countryCode?: string | null
								googlePlaceID?: string | null
								googlePrimaryType?: string | null
								media?: Array<{
									__typename: 'Media'
									mediaType: Types.MediaType
									url?: string | null
									id: string
									googleName?: string | null
									width?: number | null
									cloudflareID?: string | null
								}> | null
							} | null
							place?: {
								__typename: 'Location'
								id: string
								lat: number
								lng: number
								type?: Types.LocationType | null
								shortName?: string | null
								longName?: string | null
								address?: string | null
								countryCode?: string | null
								googlePlaceID?: string | null
								googlePrimaryType?: string | null
								media?: Array<{
									__typename: 'Media'
									mediaType: Types.MediaType
									url?: string | null
									id: string
									googleName?: string | null
									width?: number | null
									cloudflareID?: string | null
								}> | null
							} | null
							customRegion?: {
								__typename: 'Region'
								id: string
								markers?: Array<{
									__typename: 'Marker'
									id: string
									lat: number
									lng: number
								} | null> | null
							} | null
							customPin?: {
								__typename: 'Location'
								id: string
								lat: number
								lng: number
								type?: Types.LocationType | null
								shortName?: string | null
								longName?: string | null
								address?: string | null
								countryCode?: string | null
								googlePlaceID?: string | null
								googlePrimaryType?: string | null
								media?: Array<{
									__typename: 'Media'
									mediaType: Types.MediaType
									url?: string | null
									id: string
									googleName?: string | null
									width?: number | null
									cloudflareID?: string | null
								}> | null
							} | null
							requirementBlock?: {
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								icon: Types.CustomIcon
								color: Types.CustomColor
								createdAt: string
								updatedAt: string
								blockType: Types.BlockType
								procedures?: Array<{
									__typename?: 'Procedure'
									id: string
									sherpaID: string
									title: string
									description: string
									more: Array<string>
									category: Types.ProcedureCategory
									stage: Types.ProcedureStage
									lastCheckedAt?: string | null
									stillCurrentAt?: string | null
									durationInDays?: Array<string> | null
									minimumDurationInDays?: string | null
									travelPurpose?: Array<string> | null
									alternativeMeasures?: Array<string> | null
									medicalRequirements?: Array<string> | null
									documentType?: Array<string> | null
									vaccination: Types.VaccinationStatus
									enforcement?: Types.ProcedureEnforcement | null
									tags?: Array<string> | null
									sources?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									providers?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									documents?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
								}> | null
								restrictions?: Array<{
									__typename: 'Restriction'
									id: string
									sherpaID: string
									title: string
									description: string
									settingsDescriptor?: string | null
									more?: Array<string> | null
									category: Types.RestrictionCategory
									subCategory: Types.RestrictionSubCategory
									lastCheckedAt?: string | null
									stillCurrentAt?: string | null
									severity: number
									directionality?: Types.RestrictionDirectionality | null
									travelPurpose?: Array<string> | null
									tags?: Array<string> | null
									sources?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									providers?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									documents?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
								}> | null
							} | null
							procedures?: Array<{
								__typename?: 'Procedure'
								id: string
								sherpaID: string
								title: string
								description: string
								more: Array<string>
								category: Types.ProcedureCategory
								stage: Types.ProcedureStage
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								durationInDays?: Array<string> | null
								minimumDurationInDays?: string | null
								travelPurpose?: Array<string> | null
								alternativeMeasures?: Array<string> | null
								medicalRequirements?: Array<string> | null
								documentType?: Array<string> | null
								vaccination: Types.VaccinationStatus
								enforcement?: Types.ProcedureEnforcement | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
							restrictions?: Array<{
								__typename: 'Restriction'
								id: string
								sherpaID: string
								title: string
								description: string
								settingsDescriptor?: string | null
								more?: Array<string> | null
								category: Types.RestrictionCategory
								subCategory: Types.RestrictionSubCategory
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								severity: number
								directionality?: Types.RestrictionDirectionality | null
								travelPurpose?: Array<string> | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
							source?: {
								__typename: 'ExternalSource'
								id: string
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								siteName?: string | null
								title: string
								description?: string | null
							} | null
							highlight?: {
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							} | null
							sources: Array<{
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								position: number
								imageUrl?: string | null
								parentId?: string | null
								color: Types.CustomColor
								icon: Types.CustomIcon
								source?: {
									__typename: 'ExternalSource'
									id: string
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									siteName?: string | null
									title: string
									description?: string | null
								} | null
							} | null>
							routeAfter?: {
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								position: number
								parentId?: string | null
								blockType: Types.BlockType
								createdAt: string
								icon: Types.CustomIcon
								color: Types.CustomColor
								parentDayId?: string | null
								parentListId?: string | null
								rootId?: string | null
								parentDestination?: {
									__typename: 'Block'
									id: string
									title?: string | null
									description?: string | null
									icon: Types.CustomIcon
									color: Types.CustomColor
									blockType: Types.BlockType
									position: number
								} | null
								route?: {
									__typename: 'Route'
									id: string
									units: string
									distance: number
									time: number
									toll: boolean
									ferry: boolean
									isFound: boolean
									markers?: Array<{
										__typename: 'Marker'
										id: string
										lat: number
										lng: number
									} | null> | null
								} | null
							} | null
							copies?: Array<{ __typename: 'Block'; id: string }> | null
							original?: { __typename: 'Block'; id: string } | null
						} | null>
						blockAncestors: Array<{
							__typename: 'Block'
							id: string
							title?: string | null
							blockType: Types.BlockType
						} | null>
						destination?: {
							__typename: 'Location'
							id: string
							lat: number
							lng: number
							type?: Types.LocationType | null
							shortName?: string | null
							longName?: string | null
							address?: string | null
							countryCode?: string | null
							googlePlaceID?: string | null
							googlePrimaryType?: string | null
							media?: Array<{
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							}> | null
						} | null
						place?: {
							__typename: 'Location'
							id: string
							lat: number
							lng: number
							type?: Types.LocationType | null
							shortName?: string | null
							longName?: string | null
							address?: string | null
							countryCode?: string | null
							googlePlaceID?: string | null
							googlePrimaryType?: string | null
							media?: Array<{
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							}> | null
						} | null
						customRegion?: {
							__typename: 'Region'
							id: string
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
						customPin?: {
							__typename: 'Location'
							id: string
							lat: number
							lng: number
							type?: Types.LocationType | null
							shortName?: string | null
							longName?: string | null
							address?: string | null
							countryCode?: string | null
							googlePlaceID?: string | null
							googlePrimaryType?: string | null
							media?: Array<{
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							}> | null
						} | null
						requirementBlock?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							createdAt: string
							updatedAt: string
							blockType: Types.BlockType
							procedures?: Array<{
								__typename?: 'Procedure'
								id: string
								sherpaID: string
								title: string
								description: string
								more: Array<string>
								category: Types.ProcedureCategory
								stage: Types.ProcedureStage
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								durationInDays?: Array<string> | null
								minimumDurationInDays?: string | null
								travelPurpose?: Array<string> | null
								alternativeMeasures?: Array<string> | null
								medicalRequirements?: Array<string> | null
								documentType?: Array<string> | null
								vaccination: Types.VaccinationStatus
								enforcement?: Types.ProcedureEnforcement | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
							restrictions?: Array<{
								__typename: 'Restriction'
								id: string
								sherpaID: string
								title: string
								description: string
								settingsDescriptor?: string | null
								more?: Array<string> | null
								category: Types.RestrictionCategory
								subCategory: Types.RestrictionSubCategory
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								severity: number
								directionality?: Types.RestrictionDirectionality | null
								travelPurpose?: Array<string> | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
						} | null
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
						highlight?: {
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						} | null
						sources: Array<{
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							position: number
							imageUrl?: string | null
							parentId?: string | null
							color: Types.CustomColor
							icon: Types.CustomIcon
							source?: {
								__typename: 'ExternalSource'
								id: string
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								siteName?: string | null
								title: string
								description?: string | null
							} | null
						} | null>
						routeAfter?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							position: number
							parentId?: string | null
							blockType: Types.BlockType
							createdAt: string
							icon: Types.CustomIcon
							color: Types.CustomColor
							parentDayId?: string | null
							parentListId?: string | null
							rootId?: string | null
							parentDestination?: {
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								icon: Types.CustomIcon
								color: Types.CustomColor
								blockType: Types.BlockType
								position: number
							} | null
							route?: {
								__typename: 'Route'
								id: string
								units: string
								distance: number
								time: number
								toll: boolean
								ferry: boolean
								isFound: boolean
								markers?: Array<{
									__typename: 'Marker'
									id: string
									lat: number
									lng: number
								} | null> | null
							} | null
						} | null
						copies?: Array<{ __typename: 'Block'; id: string }> | null
						original?: { __typename: 'Block'; id: string } | null
					} | null>
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				} | null>
				itineraryBlocks?: Array<{
					__typename: 'Block'
					id: string
					description?: string | null
					title?: string | null
					createdAt: string
					isOrigin: boolean
					isDestination: boolean
					isRootBlock: boolean
					blockType: Types.BlockType
					parentId?: string | null
					numInList?: number | null
					numHighlights?: number | null
					rootId?: string | null
					position: number
					icon: Types.CustomIcon
					color: Types.CustomColor
					queryPosition: number
					childBlocks: Array<{
						__typename: 'Block'
						id: string
						description?: string | null
						title?: string | null
						createdAt: string
						isOrigin: boolean
						isDestination: boolean
						isRootBlock: boolean
						blockType: Types.BlockType
						parentId?: string | null
						numInList?: number | null
						numHighlights?: number | null
						rootId?: string | null
						position: number
						icon: Types.CustomIcon
						color: Types.CustomColor
						queryPosition: number
						childBlocks: Array<{
							__typename: 'Block'
							id: string
							description?: string | null
							title?: string | null
							createdAt: string
							isOrigin: boolean
							isDestination: boolean
							isRootBlock: boolean
							blockType: Types.BlockType
							parentId?: string | null
							numInList?: number | null
							numHighlights?: number | null
							rootId?: string | null
							position: number
							icon: Types.CustomIcon
							color: Types.CustomColor
							queryPosition: number
							childBlocks: Array<{
								__typename: 'Block'
								id: string
								description?: string | null
								title?: string | null
								createdAt: string
								isOrigin: boolean
								isDestination: boolean
								isRootBlock: boolean
								blockType: Types.BlockType
								parentId?: string | null
								numInList?: number | null
								numHighlights?: number | null
								rootId?: string | null
								position: number
								icon: Types.CustomIcon
								color: Types.CustomColor
								queryPosition: number
								blockAncestors: Array<{
									__typename: 'Block'
									id: string
									title?: string | null
									blockType: Types.BlockType
								} | null>
								destination?: {
									__typename: 'Location'
									id: string
									lat: number
									lng: number
									type?: Types.LocationType | null
									shortName?: string | null
									longName?: string | null
									address?: string | null
									countryCode?: string | null
									googlePlaceID?: string | null
									googlePrimaryType?: string | null
									media?: Array<{
										__typename: 'Media'
										mediaType: Types.MediaType
										url?: string | null
										id: string
										googleName?: string | null
										width?: number | null
										cloudflareID?: string | null
									}> | null
								} | null
								place?: {
									__typename: 'Location'
									id: string
									lat: number
									lng: number
									type?: Types.LocationType | null
									shortName?: string | null
									longName?: string | null
									address?: string | null
									countryCode?: string | null
									googlePlaceID?: string | null
									googlePrimaryType?: string | null
									media?: Array<{
										__typename: 'Media'
										mediaType: Types.MediaType
										url?: string | null
										id: string
										googleName?: string | null
										width?: number | null
										cloudflareID?: string | null
									}> | null
								} | null
								customRegion?: {
									__typename: 'Region'
									id: string
									markers?: Array<{
										__typename: 'Marker'
										id: string
										lat: number
										lng: number
									} | null> | null
								} | null
								customPin?: {
									__typename: 'Location'
									id: string
									lat: number
									lng: number
									type?: Types.LocationType | null
									shortName?: string | null
									longName?: string | null
									address?: string | null
									countryCode?: string | null
									googlePlaceID?: string | null
									googlePrimaryType?: string | null
									media?: Array<{
										__typename: 'Media'
										mediaType: Types.MediaType
										url?: string | null
										id: string
										googleName?: string | null
										width?: number | null
										cloudflareID?: string | null
									}> | null
								} | null
								requirementBlock?: {
									__typename: 'Block'
									id: string
									title?: string | null
									description?: string | null
									icon: Types.CustomIcon
									color: Types.CustomColor
									createdAt: string
									updatedAt: string
									blockType: Types.BlockType
									procedures?: Array<{
										__typename?: 'Procedure'
										id: string
										sherpaID: string
										title: string
										description: string
										more: Array<string>
										category: Types.ProcedureCategory
										stage: Types.ProcedureStage
										lastCheckedAt?: string | null
										stillCurrentAt?: string | null
										durationInDays?: Array<string> | null
										minimumDurationInDays?: string | null
										travelPurpose?: Array<string> | null
										alternativeMeasures?: Array<string> | null
										medicalRequirements?: Array<string> | null
										documentType?: Array<string> | null
										vaccination: Types.VaccinationStatus
										enforcement?: Types.ProcedureEnforcement | null
										tags?: Array<string> | null
										sources?: Array<{
											__typename?: 'ExternalSource'
											id: string
											type?: Types.SourceType | null
											title: string
											description?: string | null
											url: string
											imageURL?: string | null
											imageWidth?: number | null
											imageHeight?: number | null
											imageAlt?: string | null
											siteName?: string | null
											locale?: string | null
											localeAlternatives?: Array<string> | null
											sherpaID?: string | null
											provider?: string | null
											intent?: string | null
											productID?: string | null
										}> | null
										providers?: Array<{
											__typename?: 'ExternalSource'
											id: string
											type?: Types.SourceType | null
											title: string
											description?: string | null
											url: string
											imageURL?: string | null
											imageWidth?: number | null
											imageHeight?: number | null
											imageAlt?: string | null
											siteName?: string | null
											locale?: string | null
											localeAlternatives?: Array<string> | null
											sherpaID?: string | null
											provider?: string | null
											intent?: string | null
											productID?: string | null
										}> | null
										documents?: Array<{
											__typename?: 'ExternalSource'
											id: string
											type?: Types.SourceType | null
											title: string
											description?: string | null
											url: string
											imageURL?: string | null
											imageWidth?: number | null
											imageHeight?: number | null
											imageAlt?: string | null
											siteName?: string | null
											locale?: string | null
											localeAlternatives?: Array<string> | null
											sherpaID?: string | null
											provider?: string | null
											intent?: string | null
											productID?: string | null
										}> | null
									}> | null
									restrictions?: Array<{
										__typename: 'Restriction'
										id: string
										sherpaID: string
										title: string
										description: string
										settingsDescriptor?: string | null
										more?: Array<string> | null
										category: Types.RestrictionCategory
										subCategory: Types.RestrictionSubCategory
										lastCheckedAt?: string | null
										stillCurrentAt?: string | null
										severity: number
										directionality?: Types.RestrictionDirectionality | null
										travelPurpose?: Array<string> | null
										tags?: Array<string> | null
										sources?: Array<{
											__typename?: 'ExternalSource'
											id: string
											type?: Types.SourceType | null
											title: string
											description?: string | null
											url: string
											imageURL?: string | null
											imageWidth?: number | null
											imageHeight?: number | null
											imageAlt?: string | null
											siteName?: string | null
											locale?: string | null
											localeAlternatives?: Array<string> | null
											sherpaID?: string | null
											provider?: string | null
											intent?: string | null
											productID?: string | null
										}> | null
										providers?: Array<{
											__typename?: 'ExternalSource'
											id: string
											type?: Types.SourceType | null
											title: string
											description?: string | null
											url: string
											imageURL?: string | null
											imageWidth?: number | null
											imageHeight?: number | null
											imageAlt?: string | null
											siteName?: string | null
											locale?: string | null
											localeAlternatives?: Array<string> | null
											sherpaID?: string | null
											provider?: string | null
											intent?: string | null
											productID?: string | null
										}> | null
										documents?: Array<{
											__typename?: 'ExternalSource'
											id: string
											type?: Types.SourceType | null
											title: string
											description?: string | null
											url: string
											imageURL?: string | null
											imageWidth?: number | null
											imageHeight?: number | null
											imageAlt?: string | null
											siteName?: string | null
											locale?: string | null
											localeAlternatives?: Array<string> | null
											sherpaID?: string | null
											provider?: string | null
											intent?: string | null
											productID?: string | null
										}> | null
									}> | null
								} | null
								procedures?: Array<{
									__typename?: 'Procedure'
									id: string
									sherpaID: string
									title: string
									description: string
									more: Array<string>
									category: Types.ProcedureCategory
									stage: Types.ProcedureStage
									lastCheckedAt?: string | null
									stillCurrentAt?: string | null
									durationInDays?: Array<string> | null
									minimumDurationInDays?: string | null
									travelPurpose?: Array<string> | null
									alternativeMeasures?: Array<string> | null
									medicalRequirements?: Array<string> | null
									documentType?: Array<string> | null
									vaccination: Types.VaccinationStatus
									enforcement?: Types.ProcedureEnforcement | null
									tags?: Array<string> | null
									sources?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									providers?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									documents?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
								}> | null
								restrictions?: Array<{
									__typename: 'Restriction'
									id: string
									sherpaID: string
									title: string
									description: string
									settingsDescriptor?: string | null
									more?: Array<string> | null
									category: Types.RestrictionCategory
									subCategory: Types.RestrictionSubCategory
									lastCheckedAt?: string | null
									stillCurrentAt?: string | null
									severity: number
									directionality?: Types.RestrictionDirectionality | null
									travelPurpose?: Array<string> | null
									tags?: Array<string> | null
									sources?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									providers?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									documents?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
								}> | null
								source?: {
									__typename: 'ExternalSource'
									id: string
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									siteName?: string | null
									title: string
									description?: string | null
								} | null
								highlight?: {
									__typename: 'Media'
									mediaType: Types.MediaType
									url?: string | null
									id: string
									googleName?: string | null
									width?: number | null
									cloudflareID?: string | null
								} | null
								sources: Array<{
									__typename: 'Block'
									id: string
									title?: string | null
									description?: string | null
									position: number
									imageUrl?: string | null
									parentId?: string | null
									color: Types.CustomColor
									icon: Types.CustomIcon
									source?: {
										__typename: 'ExternalSource'
										id: string
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										siteName?: string | null
										title: string
										description?: string | null
									} | null
								} | null>
								routeAfter?: {
									__typename: 'Block'
									id: string
									title?: string | null
									description?: string | null
									position: number
									parentId?: string | null
									blockType: Types.BlockType
									createdAt: string
									icon: Types.CustomIcon
									color: Types.CustomColor
									parentDayId?: string | null
									parentListId?: string | null
									rootId?: string | null
									parentDestination?: {
										__typename: 'Block'
										id: string
										title?: string | null
										description?: string | null
										icon: Types.CustomIcon
										color: Types.CustomColor
										blockType: Types.BlockType
										position: number
									} | null
									route?: {
										__typename: 'Route'
										id: string
										units: string
										distance: number
										time: number
										toll: boolean
										ferry: boolean
										isFound: boolean
										markers?: Array<{
											__typename: 'Marker'
											id: string
											lat: number
											lng: number
										} | null> | null
									} | null
								} | null
								copies?: Array<{ __typename: 'Block'; id: string }> | null
								original?: { __typename: 'Block'; id: string } | null
							} | null>
							blockAncestors: Array<{
								__typename: 'Block'
								id: string
								title?: string | null
								blockType: Types.BlockType
							} | null>
							destination?: {
								__typename: 'Location'
								id: string
								lat: number
								lng: number
								type?: Types.LocationType | null
								shortName?: string | null
								longName?: string | null
								address?: string | null
								countryCode?: string | null
								googlePlaceID?: string | null
								googlePrimaryType?: string | null
								media?: Array<{
									__typename: 'Media'
									mediaType: Types.MediaType
									url?: string | null
									id: string
									googleName?: string | null
									width?: number | null
									cloudflareID?: string | null
								}> | null
							} | null
							place?: {
								__typename: 'Location'
								id: string
								lat: number
								lng: number
								type?: Types.LocationType | null
								shortName?: string | null
								longName?: string | null
								address?: string | null
								countryCode?: string | null
								googlePlaceID?: string | null
								googlePrimaryType?: string | null
								media?: Array<{
									__typename: 'Media'
									mediaType: Types.MediaType
									url?: string | null
									id: string
									googleName?: string | null
									width?: number | null
									cloudflareID?: string | null
								}> | null
							} | null
							customRegion?: {
								__typename: 'Region'
								id: string
								markers?: Array<{
									__typename: 'Marker'
									id: string
									lat: number
									lng: number
								} | null> | null
							} | null
							customPin?: {
								__typename: 'Location'
								id: string
								lat: number
								lng: number
								type?: Types.LocationType | null
								shortName?: string | null
								longName?: string | null
								address?: string | null
								countryCode?: string | null
								googlePlaceID?: string | null
								googlePrimaryType?: string | null
								media?: Array<{
									__typename: 'Media'
									mediaType: Types.MediaType
									url?: string | null
									id: string
									googleName?: string | null
									width?: number | null
									cloudflareID?: string | null
								}> | null
							} | null
							requirementBlock?: {
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								icon: Types.CustomIcon
								color: Types.CustomColor
								createdAt: string
								updatedAt: string
								blockType: Types.BlockType
								procedures?: Array<{
									__typename?: 'Procedure'
									id: string
									sherpaID: string
									title: string
									description: string
									more: Array<string>
									category: Types.ProcedureCategory
									stage: Types.ProcedureStage
									lastCheckedAt?: string | null
									stillCurrentAt?: string | null
									durationInDays?: Array<string> | null
									minimumDurationInDays?: string | null
									travelPurpose?: Array<string> | null
									alternativeMeasures?: Array<string> | null
									medicalRequirements?: Array<string> | null
									documentType?: Array<string> | null
									vaccination: Types.VaccinationStatus
									enforcement?: Types.ProcedureEnforcement | null
									tags?: Array<string> | null
									sources?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									providers?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									documents?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
								}> | null
								restrictions?: Array<{
									__typename: 'Restriction'
									id: string
									sherpaID: string
									title: string
									description: string
									settingsDescriptor?: string | null
									more?: Array<string> | null
									category: Types.RestrictionCategory
									subCategory: Types.RestrictionSubCategory
									lastCheckedAt?: string | null
									stillCurrentAt?: string | null
									severity: number
									directionality?: Types.RestrictionDirectionality | null
									travelPurpose?: Array<string> | null
									tags?: Array<string> | null
									sources?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									providers?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
									documents?: Array<{
										__typename?: 'ExternalSource'
										id: string
										type?: Types.SourceType | null
										title: string
										description?: string | null
										url: string
										imageURL?: string | null
										imageWidth?: number | null
										imageHeight?: number | null
										imageAlt?: string | null
										siteName?: string | null
										locale?: string | null
										localeAlternatives?: Array<string> | null
										sherpaID?: string | null
										provider?: string | null
										intent?: string | null
										productID?: string | null
									}> | null
								}> | null
							} | null
							procedures?: Array<{
								__typename?: 'Procedure'
								id: string
								sherpaID: string
								title: string
								description: string
								more: Array<string>
								category: Types.ProcedureCategory
								stage: Types.ProcedureStage
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								durationInDays?: Array<string> | null
								minimumDurationInDays?: string | null
								travelPurpose?: Array<string> | null
								alternativeMeasures?: Array<string> | null
								medicalRequirements?: Array<string> | null
								documentType?: Array<string> | null
								vaccination: Types.VaccinationStatus
								enforcement?: Types.ProcedureEnforcement | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
							restrictions?: Array<{
								__typename: 'Restriction'
								id: string
								sherpaID: string
								title: string
								description: string
								settingsDescriptor?: string | null
								more?: Array<string> | null
								category: Types.RestrictionCategory
								subCategory: Types.RestrictionSubCategory
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								severity: number
								directionality?: Types.RestrictionDirectionality | null
								travelPurpose?: Array<string> | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
							source?: {
								__typename: 'ExternalSource'
								id: string
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								siteName?: string | null
								title: string
								description?: string | null
							} | null
							highlight?: {
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							} | null
							sources: Array<{
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								position: number
								imageUrl?: string | null
								parentId?: string | null
								color: Types.CustomColor
								icon: Types.CustomIcon
								source?: {
									__typename: 'ExternalSource'
									id: string
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									siteName?: string | null
									title: string
									description?: string | null
								} | null
							} | null>
							routeAfter?: {
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								position: number
								parentId?: string | null
								blockType: Types.BlockType
								createdAt: string
								icon: Types.CustomIcon
								color: Types.CustomColor
								parentDayId?: string | null
								parentListId?: string | null
								rootId?: string | null
								parentDestination?: {
									__typename: 'Block'
									id: string
									title?: string | null
									description?: string | null
									icon: Types.CustomIcon
									color: Types.CustomColor
									blockType: Types.BlockType
									position: number
								} | null
								route?: {
									__typename: 'Route'
									id: string
									units: string
									distance: number
									time: number
									toll: boolean
									ferry: boolean
									isFound: boolean
									markers?: Array<{
										__typename: 'Marker'
										id: string
										lat: number
										lng: number
									} | null> | null
								} | null
							} | null
							copies?: Array<{ __typename: 'Block'; id: string }> | null
							original?: { __typename: 'Block'; id: string } | null
						} | null>
						blockAncestors: Array<{
							__typename: 'Block'
							id: string
							title?: string | null
							blockType: Types.BlockType
						} | null>
						destination?: {
							__typename: 'Location'
							id: string
							lat: number
							lng: number
							type?: Types.LocationType | null
							shortName?: string | null
							longName?: string | null
							address?: string | null
							countryCode?: string | null
							googlePlaceID?: string | null
							googlePrimaryType?: string | null
							media?: Array<{
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							}> | null
						} | null
						place?: {
							__typename: 'Location'
							id: string
							lat: number
							lng: number
							type?: Types.LocationType | null
							shortName?: string | null
							longName?: string | null
							address?: string | null
							countryCode?: string | null
							googlePlaceID?: string | null
							googlePrimaryType?: string | null
							media?: Array<{
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							}> | null
						} | null
						customRegion?: {
							__typename: 'Region'
							id: string
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
						customPin?: {
							__typename: 'Location'
							id: string
							lat: number
							lng: number
							type?: Types.LocationType | null
							shortName?: string | null
							longName?: string | null
							address?: string | null
							countryCode?: string | null
							googlePlaceID?: string | null
							googlePrimaryType?: string | null
							media?: Array<{
								__typename: 'Media'
								mediaType: Types.MediaType
								url?: string | null
								id: string
								googleName?: string | null
								width?: number | null
								cloudflareID?: string | null
							}> | null
						} | null
						requirementBlock?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							createdAt: string
							updatedAt: string
							blockType: Types.BlockType
							procedures?: Array<{
								__typename?: 'Procedure'
								id: string
								sherpaID: string
								title: string
								description: string
								more: Array<string>
								category: Types.ProcedureCategory
								stage: Types.ProcedureStage
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								durationInDays?: Array<string> | null
								minimumDurationInDays?: string | null
								travelPurpose?: Array<string> | null
								alternativeMeasures?: Array<string> | null
								medicalRequirements?: Array<string> | null
								documentType?: Array<string> | null
								vaccination: Types.VaccinationStatus
								enforcement?: Types.ProcedureEnforcement | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
							restrictions?: Array<{
								__typename: 'Restriction'
								id: string
								sherpaID: string
								title: string
								description: string
								settingsDescriptor?: string | null
								more?: Array<string> | null
								category: Types.RestrictionCategory
								subCategory: Types.RestrictionSubCategory
								lastCheckedAt?: string | null
								stillCurrentAt?: string | null
								severity: number
								directionality?: Types.RestrictionDirectionality | null
								travelPurpose?: Array<string> | null
								tags?: Array<string> | null
								sources?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								providers?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
								documents?: Array<{
									__typename?: 'ExternalSource'
									id: string
									type?: Types.SourceType | null
									title: string
									description?: string | null
									url: string
									imageURL?: string | null
									imageWidth?: number | null
									imageHeight?: number | null
									imageAlt?: string | null
									siteName?: string | null
									locale?: string | null
									localeAlternatives?: Array<string> | null
									sherpaID?: string | null
									provider?: string | null
									intent?: string | null
									productID?: string | null
								}> | null
							}> | null
						} | null
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
						highlight?: {
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						} | null
						sources: Array<{
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							position: number
							imageUrl?: string | null
							parentId?: string | null
							color: Types.CustomColor
							icon: Types.CustomIcon
							source?: {
								__typename: 'ExternalSource'
								id: string
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								siteName?: string | null
								title: string
								description?: string | null
							} | null
						} | null>
						routeAfter?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							position: number
							parentId?: string | null
							blockType: Types.BlockType
							createdAt: string
							icon: Types.CustomIcon
							color: Types.CustomColor
							parentDayId?: string | null
							parentListId?: string | null
							rootId?: string | null
							parentDestination?: {
								__typename: 'Block'
								id: string
								title?: string | null
								description?: string | null
								icon: Types.CustomIcon
								color: Types.CustomColor
								blockType: Types.BlockType
								position: number
							} | null
							route?: {
								__typename: 'Route'
								id: string
								units: string
								distance: number
								time: number
								toll: boolean
								ferry: boolean
								isFound: boolean
								markers?: Array<{
									__typename: 'Marker'
									id: string
									lat: number
									lng: number
								} | null> | null
							} | null
						} | null
						copies?: Array<{ __typename: 'Block'; id: string }> | null
						original?: { __typename: 'Block'; id: string } | null
					} | null>
					blockAncestors: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						blockType: Types.BlockType
					} | null>
					destination?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					place?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					customRegion?: {
						__typename: 'Region'
						id: string
						markers?: Array<{
							__typename: 'Marker'
							id: string
							lat: number
							lng: number
						} | null> | null
					} | null
					customPin?: {
						__typename: 'Location'
						id: string
						lat: number
						lng: number
						type?: Types.LocationType | null
						shortName?: string | null
						longName?: string | null
						address?: string | null
						countryCode?: string | null
						googlePlaceID?: string | null
						googlePrimaryType?: string | null
						media?: Array<{
							__typename: 'Media'
							mediaType: Types.MediaType
							url?: string | null
							id: string
							googleName?: string | null
							width?: number | null
							cloudflareID?: string | null
						}> | null
					} | null
					requirementBlock?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						icon: Types.CustomIcon
						color: Types.CustomColor
						createdAt: string
						updatedAt: string
						blockType: Types.BlockType
						procedures?: Array<{
							__typename?: 'Procedure'
							id: string
							sherpaID: string
							title: string
							description: string
							more: Array<string>
							category: Types.ProcedureCategory
							stage: Types.ProcedureStage
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							durationInDays?: Array<string> | null
							minimumDurationInDays?: string | null
							travelPurpose?: Array<string> | null
							alternativeMeasures?: Array<string> | null
							medicalRequirements?: Array<string> | null
							documentType?: Array<string> | null
							vaccination: Types.VaccinationStatus
							enforcement?: Types.ProcedureEnforcement | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
						restrictions?: Array<{
							__typename: 'Restriction'
							id: string
							sherpaID: string
							title: string
							description: string
							settingsDescriptor?: string | null
							more?: Array<string> | null
							category: Types.RestrictionCategory
							subCategory: Types.RestrictionSubCategory
							lastCheckedAt?: string | null
							stillCurrentAt?: string | null
							severity: number
							directionality?: Types.RestrictionDirectionality | null
							travelPurpose?: Array<string> | null
							tags?: Array<string> | null
							sources?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							providers?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
							documents?: Array<{
								__typename?: 'ExternalSource'
								id: string
								type?: Types.SourceType | null
								title: string
								description?: string | null
								url: string
								imageURL?: string | null
								imageWidth?: number | null
								imageHeight?: number | null
								imageAlt?: string | null
								siteName?: string | null
								locale?: string | null
								localeAlternatives?: Array<string> | null
								sherpaID?: string | null
								provider?: string | null
								intent?: string | null
								productID?: string | null
							}> | null
						}> | null
					} | null
					procedures?: Array<{
						__typename?: 'Procedure'
						id: string
						sherpaID: string
						title: string
						description: string
						more: Array<string>
						category: Types.ProcedureCategory
						stage: Types.ProcedureStage
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						durationInDays?: Array<string> | null
						minimumDurationInDays?: string | null
						travelPurpose?: Array<string> | null
						alternativeMeasures?: Array<string> | null
						medicalRequirements?: Array<string> | null
						documentType?: Array<string> | null
						vaccination: Types.VaccinationStatus
						enforcement?: Types.ProcedureEnforcement | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					restrictions?: Array<{
						__typename: 'Restriction'
						id: string
						sherpaID: string
						title: string
						description: string
						settingsDescriptor?: string | null
						more?: Array<string> | null
						category: Types.RestrictionCategory
						subCategory: Types.RestrictionSubCategory
						lastCheckedAt?: string | null
						stillCurrentAt?: string | null
						severity: number
						directionality?: Types.RestrictionDirectionality | null
						travelPurpose?: Array<string> | null
						tags?: Array<string> | null
						sources?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						providers?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
						documents?: Array<{
							__typename?: 'ExternalSource'
							id: string
							type?: Types.SourceType | null
							title: string
							description?: string | null
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							imageAlt?: string | null
							siteName?: string | null
							locale?: string | null
							localeAlternatives?: Array<string> | null
							sherpaID?: string | null
							provider?: string | null
							intent?: string | null
							productID?: string | null
						}> | null
					}> | null
					source?: {
						__typename: 'ExternalSource'
						id: string
						url: string
						imageURL?: string | null
						imageWidth?: number | null
						imageHeight?: number | null
						siteName?: string | null
						title: string
						description?: string | null
					} | null
					highlight?: {
						__typename: 'Media'
						mediaType: Types.MediaType
						url?: string | null
						id: string
						googleName?: string | null
						width?: number | null
						cloudflareID?: string | null
					} | null
					sources: Array<{
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						imageUrl?: string | null
						parentId?: string | null
						color: Types.CustomColor
						icon: Types.CustomIcon
						source?: {
							__typename: 'ExternalSource'
							id: string
							url: string
							imageURL?: string | null
							imageWidth?: number | null
							imageHeight?: number | null
							siteName?: string | null
							title: string
							description?: string | null
						} | null
					} | null>
					routeAfter?: {
						__typename: 'Block'
						id: string
						title?: string | null
						description?: string | null
						position: number
						parentId?: string | null
						blockType: Types.BlockType
						createdAt: string
						icon: Types.CustomIcon
						color: Types.CustomColor
						parentDayId?: string | null
						parentListId?: string | null
						rootId?: string | null
						parentDestination?: {
							__typename: 'Block'
							id: string
							title?: string | null
							description?: string | null
							icon: Types.CustomIcon
							color: Types.CustomColor
							blockType: Types.BlockType
							position: number
						} | null
						route?: {
							__typename: 'Route'
							id: string
							units: string
							distance: number
							time: number
							toll: boolean
							ferry: boolean
							isFound: boolean
							markers?: Array<{
								__typename: 'Marker'
								id: string
								lat: number
								lng: number
							} | null> | null
						} | null
					} | null
					copies?: Array<{ __typename: 'Block'; id: string }> | null
					original?: { __typename: 'Block'; id: string } | null
				}> | null
			}>
		} | null>
		owner?: {
			__typename: 'User'
			id: string
			email: string
			emailVerified: boolean
			username?: string | null
			currentName: string
			currentProfilePictureUrl: string
			hasSellerId: boolean
		} | null
	}
}

export type TripBaseQueryVariables = Types.Exact<{
	tripId: Types.Scalars['ID']['input']
}>

export type TripBaseQuery = {
	__typename?: 'Query'
	trip: {
		__typename: 'Trip'
		id: string
		title?: string | null
		description?: string | null
		departAt?: string | null
		returnAt?: string | null
		isOwner: boolean
		isPurchased: boolean
		isIndestructible: boolean
		numBlocks: number
		numHighlights: number
		numDestinations: number
		numSources: number
		unpublishedListing?: {
			__typename: 'Listing'
			hasUnpublishedChanges: boolean
			id: string
			isPublished: boolean
			rank: number
			title?: string | null
			description?: string | null
			basePrice?: number | null
			currency: string
			viewsCount: number
			thankYouMessage?: string | null
			suggestedPrice?: number | null
			avgRating: number
			numReviews: number
			owner: {
				__typename: 'User'
				id: string
				bio?: string | null
				instagramUsername?: string | null
				tiktokUsername?: string | null
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
			}
			reviews?: Array<{
				__typename: 'Review'
				id: string
				starRating: number
				feedbackToCreator?: string | null
				comment?: string | null
				createdAt: string
				reviewer: {
					__typename: 'User'
					id: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
			}> | null
		} | null
		rootBlocks: Array<{
			__typename: 'Block'
			id: string
			title?: string | null
			position: number
			description?: string | null
		} | null>
		purchasedFrom?: {
			__typename: 'Trip'
			id: string
			owner?: {
				__typename: 'User'
				id: string
				email: string
				emailVerified: boolean
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
				hasSellerId: boolean
			} | null
		} | null
		owner?: {
			__typename: 'User'
			id: string
			email: string
			emailVerified: boolean
			username?: string | null
			currentName: string
			currentProfilePictureUrl: string
			hasSellerId: boolean
		} | null
	}
}

export type TripBlocksQueryVariables = Types.Exact<{
	rootId: Types.Scalars['ID']['input']
	blockType: Types.BlockType
	destinationId?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type TripBlocksQuery = {
	__typename?: 'Query'
	blockList: Array<{
		__typename: 'Block'
		id: string
		description?: string | null
		title?: string | null
		createdAt: string
		isOrigin: boolean
		isDestination: boolean
		isRootBlock: boolean
		blockType: Types.BlockType
		parentId?: string | null
		numInList?: number | null
		numHighlights?: number | null
		rootId?: string | null
		position: number
		icon: Types.CustomIcon
		color: Types.CustomColor
		queryPosition: number
		blockAncestors: Array<{
			__typename: 'Block'
			id: string
			title?: string | null
			blockType: Types.BlockType
		} | null>
		destination?: {
			__typename: 'Location'
			id: string
			lat: number
			lng: number
			type?: Types.LocationType | null
			shortName?: string | null
			longName?: string | null
			address?: string | null
			countryCode?: string | null
			googlePlaceID?: string | null
			googlePrimaryType?: string | null
			media?: Array<{
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			}> | null
		} | null
		place?: {
			__typename: 'Location'
			id: string
			lat: number
			lng: number
			type?: Types.LocationType | null
			shortName?: string | null
			longName?: string | null
			address?: string | null
			countryCode?: string | null
			googlePlaceID?: string | null
			googlePrimaryType?: string | null
			media?: Array<{
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			}> | null
		} | null
		customRegion?: {
			__typename: 'Region'
			id: string
			markers?: Array<{ __typename: 'Marker'; id: string; lat: number; lng: number } | null> | null
		} | null
		customPin?: {
			__typename: 'Location'
			id: string
			lat: number
			lng: number
			type?: Types.LocationType | null
			shortName?: string | null
			longName?: string | null
			address?: string | null
			countryCode?: string | null
			googlePlaceID?: string | null
			googlePrimaryType?: string | null
			media?: Array<{
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			}> | null
		} | null
		requirementBlock?: {
			__typename: 'Block'
			id: string
			title?: string | null
			description?: string | null
			icon: Types.CustomIcon
			color: Types.CustomColor
			createdAt: string
			updatedAt: string
			blockType: Types.BlockType
			procedures?: Array<{
				__typename?: 'Procedure'
				id: string
				sherpaID: string
				title: string
				description: string
				more: Array<string>
				category: Types.ProcedureCategory
				stage: Types.ProcedureStage
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				durationInDays?: Array<string> | null
				minimumDurationInDays?: string | null
				travelPurpose?: Array<string> | null
				alternativeMeasures?: Array<string> | null
				medicalRequirements?: Array<string> | null
				documentType?: Array<string> | null
				vaccination: Types.VaccinationStatus
				enforcement?: Types.ProcedureEnforcement | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
			restrictions?: Array<{
				__typename: 'Restriction'
				id: string
				sherpaID: string
				title: string
				description: string
				settingsDescriptor?: string | null
				more?: Array<string> | null
				category: Types.RestrictionCategory
				subCategory: Types.RestrictionSubCategory
				lastCheckedAt?: string | null
				stillCurrentAt?: string | null
				severity: number
				directionality?: Types.RestrictionDirectionality | null
				travelPurpose?: Array<string> | null
				tags?: Array<string> | null
				sources?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				providers?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
				documents?: Array<{
					__typename?: 'ExternalSource'
					id: string
					type?: Types.SourceType | null
					title: string
					description?: string | null
					url: string
					imageURL?: string | null
					imageWidth?: number | null
					imageHeight?: number | null
					imageAlt?: string | null
					siteName?: string | null
					locale?: string | null
					localeAlternatives?: Array<string> | null
					sherpaID?: string | null
					provider?: string | null
					intent?: string | null
					productID?: string | null
				}> | null
			}> | null
		} | null
		procedures?: Array<{
			__typename?: 'Procedure'
			id: string
			sherpaID: string
			title: string
			description: string
			more: Array<string>
			category: Types.ProcedureCategory
			stage: Types.ProcedureStage
			lastCheckedAt?: string | null
			stillCurrentAt?: string | null
			durationInDays?: Array<string> | null
			minimumDurationInDays?: string | null
			travelPurpose?: Array<string> | null
			alternativeMeasures?: Array<string> | null
			medicalRequirements?: Array<string> | null
			documentType?: Array<string> | null
			vaccination: Types.VaccinationStatus
			enforcement?: Types.ProcedureEnforcement | null
			tags?: Array<string> | null
			sources?: Array<{
				__typename?: 'ExternalSource'
				id: string
				type?: Types.SourceType | null
				title: string
				description?: string | null
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				imageAlt?: string | null
				siteName?: string | null
				locale?: string | null
				localeAlternatives?: Array<string> | null
				sherpaID?: string | null
				provider?: string | null
				intent?: string | null
				productID?: string | null
			}> | null
			providers?: Array<{
				__typename?: 'ExternalSource'
				id: string
				type?: Types.SourceType | null
				title: string
				description?: string | null
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				imageAlt?: string | null
				siteName?: string | null
				locale?: string | null
				localeAlternatives?: Array<string> | null
				sherpaID?: string | null
				provider?: string | null
				intent?: string | null
				productID?: string | null
			}> | null
			documents?: Array<{
				__typename?: 'ExternalSource'
				id: string
				type?: Types.SourceType | null
				title: string
				description?: string | null
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				imageAlt?: string | null
				siteName?: string | null
				locale?: string | null
				localeAlternatives?: Array<string> | null
				sherpaID?: string | null
				provider?: string | null
				intent?: string | null
				productID?: string | null
			}> | null
		}> | null
		restrictions?: Array<{
			__typename: 'Restriction'
			id: string
			sherpaID: string
			title: string
			description: string
			settingsDescriptor?: string | null
			more?: Array<string> | null
			category: Types.RestrictionCategory
			subCategory: Types.RestrictionSubCategory
			lastCheckedAt?: string | null
			stillCurrentAt?: string | null
			severity: number
			directionality?: Types.RestrictionDirectionality | null
			travelPurpose?: Array<string> | null
			tags?: Array<string> | null
			sources?: Array<{
				__typename?: 'ExternalSource'
				id: string
				type?: Types.SourceType | null
				title: string
				description?: string | null
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				imageAlt?: string | null
				siteName?: string | null
				locale?: string | null
				localeAlternatives?: Array<string> | null
				sherpaID?: string | null
				provider?: string | null
				intent?: string | null
				productID?: string | null
			}> | null
			providers?: Array<{
				__typename?: 'ExternalSource'
				id: string
				type?: Types.SourceType | null
				title: string
				description?: string | null
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				imageAlt?: string | null
				siteName?: string | null
				locale?: string | null
				localeAlternatives?: Array<string> | null
				sherpaID?: string | null
				provider?: string | null
				intent?: string | null
				productID?: string | null
			}> | null
			documents?: Array<{
				__typename?: 'ExternalSource'
				id: string
				type?: Types.SourceType | null
				title: string
				description?: string | null
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				imageAlt?: string | null
				siteName?: string | null
				locale?: string | null
				localeAlternatives?: Array<string> | null
				sherpaID?: string | null
				provider?: string | null
				intent?: string | null
				productID?: string | null
			}> | null
		}> | null
		source?: {
			__typename: 'ExternalSource'
			id: string
			url: string
			imageURL?: string | null
			imageWidth?: number | null
			imageHeight?: number | null
			siteName?: string | null
			title: string
			description?: string | null
		} | null
		highlight?: {
			__typename: 'Media'
			mediaType: Types.MediaType
			url?: string | null
			id: string
			googleName?: string | null
			width?: number | null
			cloudflareID?: string | null
		} | null
		sources: Array<{
			__typename: 'Block'
			id: string
			title?: string | null
			description?: string | null
			position: number
			imageUrl?: string | null
			parentId?: string | null
			color: Types.CustomColor
			icon: Types.CustomIcon
			source?: {
				__typename: 'ExternalSource'
				id: string
				url: string
				imageURL?: string | null
				imageWidth?: number | null
				imageHeight?: number | null
				siteName?: string | null
				title: string
				description?: string | null
			} | null
		} | null>
		routeAfter?: {
			__typename: 'Block'
			id: string
			title?: string | null
			description?: string | null
			position: number
			parentId?: string | null
			blockType: Types.BlockType
			createdAt: string
			icon: Types.CustomIcon
			color: Types.CustomColor
			parentDayId?: string | null
			parentListId?: string | null
			rootId?: string | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			route?: {
				__typename: 'Route'
				id: string
				units: string
				distance: number
				time: number
				toll: boolean
				ferry: boolean
				isFound: boolean
				markers?: Array<{
					__typename: 'Marker'
					id: string
					lat: number
					lng: number
				} | null> | null
			} | null
		} | null
		copies?: Array<{ __typename: 'Block'; id: string }> | null
		original?: { __typename: 'Block'; id: string } | null
	} | null>
}

export type TripListingQueryVariables = Types.Exact<{
	tripId: Types.Scalars['ID']['input']
}>

export type TripListingQuery = {
	__typename?: 'Query'
	trip: {
		__typename: 'Trip'
		id: string
		title?: string | null
		description?: string | null
		departAt?: string | null
		returnAt?: string | null
		isOwner: boolean
		isIndestructible: boolean
		numDestinations: number
		numBlocks: number
		numSources: number
		numHighlights: number
		isPurchased: boolean
		weekendCostRangeUpper?: number | null
		weekendCostRangeLower?: number | null
		weekCostRangeUpper?: number | null
		weekCostRangeLower?: number | null
		monthCostRangeUpper?: number | null
		monthCostRangeLower?: number | null
		categories?: Array<string> | null
		purchasedFrom?: { __typename: 'Trip'; id: string } | null
		unpublishedListing?: {
			__typename: 'Listing'
			id: string
			isPublished: boolean
			rank: number
			title?: string | null
			description?: string | null
			basePrice?: number | null
			currency: string
			viewsCount: number
			thankYouMessage?: string | null
			suggestedPrice?: number | null
			avgRating: number
			numReviews: number
			owner: {
				__typename: 'User'
				id: string
				bio?: string | null
				instagramUsername?: string | null
				tiktokUsername?: string | null
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
			}
			reviews?: Array<{
				__typename: 'Review'
				id: string
				starRating: number
				feedbackToCreator?: string | null
				comment?: string | null
				createdAt: string
				reviewer: {
					__typename: 'User'
					id: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
			}> | null
		} | null
		owner?: {
			__typename: 'User'
			id: string
			email: string
			username?: string | null
			currentName: string
			currentProfilePictureUrl: string
		} | null
		featuredHighlights: Array<{
			__typename: 'Block'
			featuredImagePosition?: number | null
			id: string
			title?: string | null
			description?: string | null
			position: number
			parentId?: string | null
			blockType: Types.BlockType
			createdAt: string
			icon: Types.CustomIcon
			color: Types.CustomColor
			highlightPosition: number
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
				position: number
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
		} | null>
		yourPurchase?: {
			__typename: 'Purchase'
			id: string
			review?: { __typename: 'Review'; id: string } | null
		} | null
	}
}

export type TripPurchaseQueryVariables = Types.Exact<{
	listingId: Types.Scalars['ID']['input']
}>

export type TripPurchaseQuery = {
	__typename?: 'Query'
	listing: {
		__typename: 'Listing'
		id: string
		basePrice?: number | null
		currentTrip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			description?: string | null
			numBlocks: number
			numDestinations: number
			numHighlights: number
			numSources: number
			owner?: {
				__typename: 'User'
				id: string
				currentName: string
				currentProfilePictureUrl: string
				username?: string | null
			} | null
		}
	}
}

export type PublicTripQueryVariables = Types.Exact<{
	tripId: Types.Scalars['ID']['input']
}>

export type PublicTripQuery = {
	__typename?: 'Query'
	publicTrip: {
		__typename: 'Trip'
		id: string
		title?: string | null
		description?: string | null
		numBlocks: number
		numDestinations: number
		numHighlights: number
		numSources: number
		previewBlocks: Array<string | null>
		listing?: {
			__typename: 'Listing'
			id: string
			title?: string | null
			description?: string | null
			isPublished: boolean
		} | null
	}
}

export type FeaturedHighlightsTripQueryVariables = Types.Exact<{
	tripId: Types.Scalars['ID']['input']
}>

export type FeaturedHighlightsTripQuery = {
	__typename?: 'Query'
	trip: {
		__typename: 'Trip'
		id: string
		tripHighlights: Array<{
			__typename: 'Block'
			featuredImagePosition?: number | null
			id: string
			title?: string | null
			description?: string | null
			position: number
			parentId?: string | null
			blockType: Types.BlockType
			createdAt: string
			icon: Types.CustomIcon
			color: Types.CustomColor
			highlightPosition: number
			copies?: Array<{ __typename: 'Block'; id: string }> | null
			original?: { __typename: 'Block'; id: string } | null
			parentBlock?: {
				__typename: 'Block'
				id: string
				title?: string | null
				blockType: Types.BlockType
				position: number
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
			} | null
			parentDestination?: {
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				blockType: Types.BlockType
				position: number
			} | null
			highlight?: {
				__typename: 'Media'
				mediaType: Types.MediaType
				url?: string | null
				id: string
				googleName?: string | null
				width?: number | null
				cloudflareID?: string | null
			} | null
		} | null>
	}
}

export type PreviewTripQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input']
}>

export type PreviewTripQuery = {
	__typename?: 'Query'
	previewTrip: {
		__typename: 'Trip'
		id: string
		title?: string | null
		description?: string | null
		departAt?: string | null
		returnAt?: string | null
		isOwner: boolean
		isPurchased: boolean
		isIndestructible: boolean
		unpublishedListing?: {
			__typename: 'Listing'
			id: string
			isPublished: boolean
			rank: number
			title?: string | null
			description?: string | null
			basePrice?: number | null
			currency: string
			viewsCount: number
			thankYouMessage?: string | null
			suggestedPrice?: number | null
			avgRating: number
			numReviews: number
			owner: {
				__typename: 'User'
				id: string
				bio?: string | null
				instagramUsername?: string | null
				tiktokUsername?: string | null
				username?: string | null
				currentName: string
				currentProfilePictureUrl: string
			}
			reviews?: Array<{
				__typename: 'Review'
				id: string
				starRating: number
				feedbackToCreator?: string | null
				comment?: string | null
				createdAt: string
				reviewer: {
					__typename: 'User'
					id: string
					username?: string | null
					currentName: string
					currentProfilePictureUrl: string
				}
			}> | null
		} | null
	}
}

export type HighlightsQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input']
	blockId?: Types.InputMaybe<Types.Scalars['ID']['input']>
	itineraryId?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type HighlightsQuery = {
	__typename?: 'Query'
	highlights: {
		__typename: 'HighlightResult'
		id: string
		trip: {
			__typename: 'Trip'
			id: string
			title?: string | null
			numBlocks: number
			isPurchased: boolean
		}
		highlightGroups: Array<{
			__typename: 'HighlightGroup'
			id: string
			parentBlock: {
				__typename: 'Block'
				id: string
				blockType: Types.BlockType
				position: number
				description?: string | null
				title?: string | null
				icon: Types.CustomIcon
				color: Types.CustomColor
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
			}
			highlightBlocks: Array<{
				__typename: 'Block'
				id: string
				title?: string | null
				description?: string | null
				position: number
				parentId?: string | null
				blockType: Types.BlockType
				createdAt: string
				icon: Types.CustomIcon
				color: Types.CustomColor
				highlightPosition: number
				copies?: Array<{ __typename: 'Block'; id: string }> | null
				original?: { __typename: 'Block'; id: string } | null
				parentBlock?: {
					__typename: 'Block'
					id: string
					title?: string | null
					blockType: Types.BlockType
					position: number
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
				} | null
				parentDestination?: {
					__typename: 'Block'
					id: string
					title?: string | null
					description?: string | null
					icon: Types.CustomIcon
					color: Types.CustomColor
					blockType: Types.BlockType
					position: number
				} | null
				highlight?: {
					__typename: 'Media'
					mediaType: Types.MediaType
					url?: string | null
					id: string
					googleName?: string | null
					width?: number | null
					cloudflareID?: string | null
				} | null
			}>
		} | null>
	}
}

export const TripDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Trip' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'trip' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'categories' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'orderedBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'rootBlock' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'destinationSegments' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'DestinationSegmentFields' },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'DestinationSegmentFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DestinationSegment' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destinationBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'extraBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExtraBlocksFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'itineraryBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ItineraryBlocksFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExtraBlocksFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LayeredBlocksFields' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LayeredBlocksFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'childBlocks' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ItineraryBlocksFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'childBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LayeredBlocksFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const TripBaseDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'TripBase' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'trip' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripBaseFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'UserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'hasSellerId' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripBaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rootBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserFields' } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
export const TripBlocksDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'TripBlocks' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'rootId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'blockType' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlockType' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationId' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockList' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'rootId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'rootId' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'blockType' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'blockType' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'destinationId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'destinationId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BlockFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOrigin' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isDestination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isRootBlock' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numInList' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'queryPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'blockAncestors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'destination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'place' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customRegion' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomRegionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'customPin' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LocationFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requirementBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'RequirementsBlockFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'routeAfter' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteBlockFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'LocationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Location' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'shortName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'longName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'address' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePlaceID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googlePrimaryType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'media' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'CustomRegionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Region' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RequirementsBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'procedures' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProcedureFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'restrictions' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RestrictionFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ProcedureFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Procedure' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'durationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'minimumDurationInDays' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'alternativeMeasures' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'medicalRequirements' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'documentType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'vaccination' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'enforcement' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ExternalSourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageAlt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'locale' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'localeAlternatives' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'provider' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'intent' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'productID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RestrictionFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Restriction' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'sherpaID' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'settingsDescriptor' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'more' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'category' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'subCategory' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'lastCheckedAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'stillCurrentAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'severity' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'directionality' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'travelPurpose' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'tags' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'sources' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'providers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'documents' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExternalSourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExternalSource' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageURL' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageWidth' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageHeight' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'SourceBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'source' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SourceFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'parentDayId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentListId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rootId' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'route' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RouteFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'RouteFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Route' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'units' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'distance' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'time' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'toll' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'ferry' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isFound' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'markers' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lat' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'lng' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
export const TripListingDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'TripListing' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'trip' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublishListingFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublishListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripsFields' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'purchasedFrom' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripsFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekendCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'weekCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeUpper' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'monthCostRangeLower' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'categories' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicUserFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'unpublishedListing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'featuredHighlights' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HighlightBlockFields' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'featuredImagePosition' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'yourPurchase' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'review' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicUserFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'HighlightBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'highlightPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
export const TripPurchaseDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'TripPurchase' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'listingId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'listing' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'listingId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripPurchaseFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'TripPurchaseFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'currentTrip' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'owner' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
export const PublicTripDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'PublicTrip' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'publicTrip' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicTripFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicTripFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trip' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numDestinations' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numHighlights' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numSources' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'previewBlocks' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'listing' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
export const FeaturedHighlightsTripDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'featuredHighlightsTrip' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'trip' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'tripId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'tripHighlights' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'HighlightBlockFields' },
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'featuredImagePosition' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'HighlightBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'highlightPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
export const PreviewTripDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'PreviewTrip' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'previewTrip' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'departAt' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'returnAt' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'isIndestructible' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'unpublishedListing' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ListingFields' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ListingFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Listing' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'rank' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'basePrice' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'viewsCount' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'thankYouMessage' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'suggestedPrice' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'owner' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'bio' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'tiktokUsername' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'avgRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'numReviews' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviews' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PublicReviewFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'PublicReviewFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Review' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'feedbackToCreator' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'comment' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'reviewer' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'username' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentName' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currentProfilePictureUrl' } },
							],
						},
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
				],
			},
		},
	],
} as unknown as DocumentNode
export const HighlightsDocument = /*#__PURE__*/ {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Highlights' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'blockId' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'itineraryId' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlights' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'blockId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'blockId' } },
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'itineraryId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'itineraryId' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'trip' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'numBlocks' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
										],
									},
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'highlightGroups' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'HighlightGroupFields' },
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'MediaFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Media' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'mediaType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'url' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'googleName' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'cloudflareID' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ParentDestinationFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'HighlightBlockFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Block' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'highlightPosition' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'copies' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'original' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentDestination' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ParentDestinationFields' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlight' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MediaFields' } },
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'HighlightGroupFields' },
			typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HighlightGroup' } },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'parentBlock' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'blockType' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'parentDestination' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'FragmentSpread',
												name: { kind: 'Name', value: 'ParentDestinationFields' },
											},
										],
									},
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'position' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'description' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'icon' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'color' } },
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'highlightBlocks' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HighlightBlockFields' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode
